import { withFieldHint } from "@/src/components/HighOrderComponents";
import { DatePickerField } from "@/src/components/Fields/DataPickerField";
import { useFormContext } from "react-hook-form";

import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";
import { USE_SELECT_FIELD_UPDATE_DELAY } from "@/src/shared/const/delay";

const DatePickerWithHint = withFieldHint(DatePickerField);

export function DateInput(props: any) {
  const { hint, name, format } = props;
  const hints = hint?.hintsList;
  const form = useFormContext();
  const { control } = form;
  const debouncedUpdateField = useFieldDebouncedCallback(
    name,
    USE_SELECT_FIELD_UPDATE_DELAY,
  );
  return (
    <DatePickerWithHint
      {...props}
      control={control}
      name={name}
      onChange={(value, _, ref) => {
        if (ref?.current && !ref.current?.closest('[role="dialog"]')) {
          debouncedUpdateField(value);
        }
      }}
      hints={hints}
      format={format}
    />
  );
}
